import { create } from 'zustand';
import { DEFAULT_SETTINGS } from '@shared/defaults';
import type { PlatformSettings } from '@shared/types';
import { api, errorMessage } from '../../lib/api';

/** 平台设置缓存（告警阈值默认值、看板频率等）。 */
interface SettingsStore {
  settings: PlatformSettings;
  loading: boolean;
  loaded: boolean;
  error: string | null;
  load: (options?: { force?: boolean }) => Promise<void>;
  save: (patch: Partial<PlatformSettings>) => Promise<PlatformSettings>;
}

export const useSettingsStore = create<SettingsStore>((set, get) => ({
  settings: DEFAULT_SETTINGS,
  loading: false,
  loaded: false,
  error: null,

  async load(options) {
    if (get().loading) return;
    if (get().loaded && !options?.force) return;
    set({ loading: true, error: null });
    try {
      const settings = await api.get<PlatformSettings>('/api/settings');
      set({ settings, loading: false, loaded: true });
    } catch (error) {
      set({ loading: false, error: errorMessage(error) });
    }
  },

  async save(patch) {
    const settings = await api.patch<PlatformSettings>('/api/settings', patch);
    set({ settings, loaded: true, error: null });
    return settings;
  },
}));
